import { Component, OnInit } from '@angular/core';
import { OptionsList, OptionsListMulti } from 'gung-common';
import { CheckoutStepComponent, Customer, CustomerService, MetadataService, SelectedCustomerService } from 'gung-standard';
import { first, forkJoin } from 'rxjs';
import { HLDisplayCheckoutUtilService } from '../../../services/hldisplay-checkout-util.service';

@Component({
  selector: 'app-hl-display-customer-service-payment-information-step-portal',
  templateUrl: './hl-display-customer-service-payment-information-step-portal.component.html',
  styleUrl: './hl-display-customer-service-payment-information-step-portal.component.css',
  standalone: false
})
export class HlDisplayCustomerServicePaymentInformationStepPortalComponent
  extends CheckoutStepComponent
  implements OnInit {
  public payerCompanyOptions: OptionsListMulti[] = [];
  public selectedCustomer: Customer;
  public paymentTermsOptions: OptionsList[] = [];

  startPayerCompanyId: string = '';
  public highlightEmailFields: boolean = false;
  public showEmailWarning: boolean = false;

  constructor(
    protected customerService: CustomerService,
    protected selectedCustomerService: SelectedCustomerService,
    protected hlDisplayCheckoutUtilService: HLDisplayCheckoutUtilService,
    protected metadataService: MetadataService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.onNextBtnClicked.subscribe(_ => this.handleNextButtonClicked());

    forkJoin({
      selectedCustomer: this.selectedCustomerService.getSelectedCustomer().pipe(first()),
      payerCompany: this.customerService.getCustomer(this.checkout.extra.oh.kundbetalarenr).pipe(first())
    }).subscribe(({ selectedCustomer, payerCompany }) => {
      this.selectedCustomer = selectedCustomer;
      this.startPayerCompanyId = payerCompany.id;

      this.paymentTermsOptions = this.metadataService.getMetadataTableList('x2')
        .filter(mv => mv.betkod === 'AD' || mv.betkod === selectedCustomer.extra?.kus?.betkod)
        .map(mv => {
          return {
            id: mv.betkod,
            name: mv.betvillbeskr
          };
        });

      this.setInitialValues();
    });
  }

  public getLabel(): string {
    return 'PAYMENT';
  }

  protected handleNextButtonClicked(): void {
    this.stepDone.emit(this.checkout);
  }

  private setInitialValues(): void {
    const oh = this.checkout.extra.oh;
    const kus = this.selectedCustomer?.extra?.kus;
    const emailFromContactsThatShouldReceiveInvoice = this.findFirstContactThatShouldReceiveEmail(this.selectedCustomer);

    this.checkout.extra.oh = {
      ...oh,
      betkod: oh.betkod ?? (kus?.betkod || undefined),
      faktslutlevorder: oh.faktslutlevorder ?? (kus?.faktslutlevorder || undefined),
      q_hl_emailnotification: oh.q_hl_emailnotification ?? (kus?.q_hl_emailnotification || undefined),
      samfaktutskr: oh.samfaktutskr ?? (kus?.samfaktutskr === '1'),
      q_hl_edi_cancel: oh.q_hl_edi_cancel ?? (kus?.q_no_edi_invoice || undefined), // Different prefix in Jeeves
      q_hl_emailaddr_to: oh.q_hl_emailaddr_to ?? (emailFromContactsThatShouldReceiveInvoice || kus?.q_hl_mail_invoicecc || undefined),
      q_hl_emailaddr_cc: oh.q_hl_emailaddr_cc ?? (kus?.q_hl_mail_invoicecc || undefined)
    };
  }

  emitSkipAdminFee(): void {
    this.checkout.extra._skipAdminFee = !this.checkout.extra._skipAdminFee;
    this.hlDisplayCheckoutUtilService.emitSkipAdminFeeEvent(this.checkout.extra._skipAdminFee);
  }

  private findFirstContactThatShouldReceiveEmail(selectedCustomer: Customer): string {
    if (selectedCustomer.extra?.crMapped && Object.keys(selectedCustomer.extra?.crMapped).length > 0) {

      const contact: any = Object.values(selectedCustomer.extra?.crMapped).find((cr: any) => cr.data?.q_hl_send_email === "1");
      if (contact) {
        return contact.data.comnr;
      }
    }

    return null;
  }

  public ignoreAllBrokenBoxFeeChanged(): void {
    this.checkout.extra._ignoreAllBrokenBoxFees = !this.checkout.extra._ignoreAllBrokenBoxFees;
    this.hlDisplayCheckoutUtilService.emitSkipBrokenBoxFeeEvent(this.checkout.extra._ignoreAllBrokenBoxFees);
  }

  public customerSelected(customer: Customer): void {
    this.checkout.extra.oh.kundbetalarenr = customer.id;
    this.highlightEmailFields = true;
    this.showEmailWarning = true;
    setTimeout(() => {
      this.highlightEmailFields = false;
    }, 3000);
  }
}
